import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BusinessDashboardComponent } from '../business/business-pages/business-dashboard/business-dashboard/business-dashboard.component';
import { AuthGuard } from '../core/_constants/guards/auth.guard';
import { RouteConstant } from '../core/_constants/route.constant';
import { BusinessWrapperComponent } from './business-wrapper/business-wrapper.component';
import { WrapperComponent } from './wrapper/wrapper.component';
import { AuthService } from '../services/authguard/auth.service';

import { ProductDetailComponent } from './product-detail/product-detail.component';
// import { ProductComponent } from './product/product.component';
import { MachineComponent } from './machine/machine.component';
import { ServiceComponent } from './service/service.component';
import { ToolsComponent } from './tools/tools.component';
import { RawMaterialsComponent } from './raw-materials/raw-materials.component';
import { ProductListingComponent } from './product-listing/product-listing/product-listing.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { MainHomeComponent } from './main-home/main-home.component';
import { BlogsComponent } from '../auth/blogs/blogs.component';
const routes: Routes = [
  {
    path: RouteConstant.main,
    component: WrapperComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../modules/pages/pages.module').then((v) => v.PagesModule),
      },
    ],
    canLoad: [AuthService]
  },
  {
    path: RouteConstant.business,
    component: BusinessWrapperComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../business/business-pages/business-pages.module').then((v) => v.BusinessPagesModule),
      },
    ],
    canLoad: [AuthService]
  },

  {
    path: RouteConstant.productdetail,
    component: ProductDetailComponent,
    //   children: [
    //     {
    //       path: '',
    //       loadChildren: () =>
    //         import('../business/business-pages/business-pages.module').then((v) => v.BusinessPagesModule),
    //     },
    //   ],
    //   canLoad:[AuthService]
  },
  {
    path: RouteConstant.machine,
    component: MachineComponent,
    // children: [
    //   {
    //     path: '',
    //     loadChildren: () =>
    //       import('../business/business-pages/business-pages.module').then((v) => v.BusinessPagesModule),
    //   },
    // ],
    canLoad: [AuthService]
  },
  {
    path: RouteConstant.service,
    component: ServiceComponent,
    // children: [
    //   {
    //     path: '',
    //     loadChildren: () =>
    //       import('../business/business-pages/business-pages.module').then((v) => v.BusinessPagesModule),
    //   },
    // ],
    canLoad: [AuthService]
  },
  {
    path: RouteConstant.productListing,
    component: ProductListingComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../layout/product-listing/product-listing.module').then((v) => v.ProductListingModule),
      },
    ],
    canLoad: [AuthService]
  },
  {
    path: RouteConstant.tools,
    component: ToolsComponent,
    canLoad: [AuthService]
  },
  {
    path: RouteConstant.rawmaterials,
    component: RawMaterialsComponent,
    canLoad: [AuthService]
  }
  ,
  {
    path: RouteConstant.SearchResults,
    component: SearchResultsComponent,
  }
  ,
  {
    path: RouteConstant.mainhome,
    component: MainHomeComponent,
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule { }
